/*
 * SHULZ — PREVENTA por variante.
 *
 * Se engancha al mismo evento `change` que usa el tema (VariantSelects /
 * VariantRadios). Cuando el evento llega a `document`, el componente ya
 * ejecutó updateMasterId() de forma sincrónica, así que `currentVariant`
 * está actualizado: no hace falta setTimeout.
 *
 * La visibilidad se controla con `data-state` + CSS. renderProductInfo() del
 * tema sólo cambia `disabled` y el texto del botón (nunca su display), por lo
 * que su respuesta asíncrona no puede pisar este estado.
 */
(() => {
  if (window.shulzPreventaReady) return;
  window.shulzPreventaReady = true;

  const readPreventaIds = (cta) => {
    const script = cta.querySelector("script[data-preventa-variants]");
    if (!script) return new Set();
    try {
      return new Set(JSON.parse(script.textContent).map(String));
    } catch (error) {
      return new Set();
    }
  };

  const stateFor = (variant, preventaIds) => {
    if (!variant) return "soldout";
    if (variant.available) return "available";
    return preventaIds.has(String(variant.id)) ? "preventa" : "soldout";
  };

  const whatsappHref = (cta, variant) => {
    let message = `Hola! Tengo una consulta sobre ${cta.dataset.productTitle}`;
    if (variant && cta.dataset.defaultVariant !== "true") {
      message += ` - ${variant.title}`;
    }
    return `https://web.whatsapp.com/send?phone=${cta.dataset.whatsappPhone}&text=${encodeURIComponent(message)}`;
  };

  // Formulario principal y barra fija (--alt) comparten el mismo section id.
  const syncSection = (sectionId, variant) => {
    document
      .querySelectorAll(`.preventa-cta[data-section="${CSS.escape(sectionId)}"]`)
      .forEach((cta) => {
        cta.dataset.state = stateFor(variant, readPreventaIds(cta));
        const link = cta.querySelector("[data-preventa-whatsapp]");
        if (link) link.href = whatsappHref(cta, variant);
      });
  };

  document.addEventListener("change", (event) => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest("variant-radios, variant-selects");
    if (!picker || !picker.dataset.section) return;
    syncSection(picker.dataset.section, picker.currentVariant);
  });
})();
